import { adminModuleQuery, useModule } from 'system/structure-modules';

export default function AdminPuppetToolsScreen() {
    const { PuppetToolsScreen } = useModule(adminModuleQuery);
    return <PuppetToolsScreen />;
}
